export default Object.freeze({
  AutomyManaged: 1,
  DistributorManaged: 2,
});
